import { dateToday } from "../date-today";

const production = {
  environment: "PRE_PROD",
  et3arrafLink: "https://www.et3arraf.com",
  API_URL: "https://admin-preprod-khattabat-server.alkhattaba.app/",
  file_center: "http://et3-uploads.s3.amazonaws.com/",
  voiceAttachmentUrl: "https://s3-eu-west-1.amazonaws.com/et3-voice/",
  imageAttachmentUrl:
    "https://s3-eu-west-1.amazonaws.com/et3-attachment-image/",
  pictureUrl: "https://s3-eu-west-1.amazonaws.com/et3-uploads/",
  selfiePictureUrl: "https://s3-eu-west-1.amazonaws.com/et3-selfie-image/",
  env: "PreProd",
  date: dateToday,
  IS_UNDER_CONSTRUCTION: false,

  version: "7.3.5",

  encryptData: "ADMIN2021ET3#ET3#",
  pass: "iamAdmin#111#Trust##Me#letMEInET3#",

  apiKey: "AIzaSyBiNhY2TMRK4weeG_vhtS9a9gZcruMpPhM",
  authDomain: "psyched-throne-686.firebaseapp.com",
  projectId: "psyched-throne-686",
  storageBucket: "psyched-throne-686.appspot.com",
  messagingSenderId: "941123057427",
  appId: "1:941123057427:web:cf3b2cf46a2536f3a48ce6",
  firebaseVapidKey: "BAHQDRyHKh-CAkk4iXAPHBNnp2zYgdPapEf1ywjXYiWIjtzTIVUXEtuGF-4XAedR53D4QnqF_pshwfYwstf3UM4"
};
export default production;
